import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import React from 'react';
import InternalError from './InternalError';

/* eslint-disable react/prefer-stateless-function */
class ErrorBoundary extends React.Component {
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    static propTypes = {
        children: PropTypes.node.isRequired,
        location: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            if (this.state.hasError !== false) {
                this.setState({ hasError: false });
            }
        }
    }

    componentDidCatch(error, info) {
        // just in case
        console.info('We have problems!', error, info);
        Sentry.withScope((scope) => {
            try {
                scope.setExtras(info);
                scope.setTags({
                    by: 'error-boundary',
                    stage: process.env.BUILD_ENV,
                    build: process.env.NODE_ENV,
                });
                Sentry.captureException(error);
            } catch {}
        });
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return <InternalError />;
        }

        return <React.Fragment>{children}</React.Fragment>;
    }
}

export default withRouter(ErrorBoundary);
